import * as types from "./types";
import { ResponseErrorState } from "@stores/ui/responseError/types";

export const fetchStarted = () => ({ type: types.FETCH_STARTED } as const);
export const fetch = (res: types.UsageResultsState) =>
  ({ type: types.FETCH, payload: res } as const);
export const fetchFailed = (err: { error: { response: ResponseErrorState } }) =>
  ({ type: types.FETCH_FAILED, error: err } as const);

export const postStarted = () => ({ type: types.POST_STARTED } as const);
export const post = (res: types.UsageResultsState) =>
  ({ type: types.POST, payload: res } as const);
export const postFailed = (err: { error: { response: ResponseErrorState } }) =>
  ({ type: types.POST_FAILED, error: err } as const);
export const unsetReport = () => ({ type: types.UNSET_REPORT } as const);

export type ActionTypes =
  | ReturnType<typeof fetchStarted>
  | ReturnType<typeof fetch>
  | ReturnType<typeof fetchFailed>
  | ReturnType<typeof postStarted>
  | ReturnType<typeof post>
  | ReturnType<typeof postFailed>
  | ReturnType<typeof unsetReport>;
